import { getChainIcon } from '@particle-network/connector-core';
import CustomQRCode from '../../components/CustomQRCode';
import CopyToClipboard from '../../components/copyToClipboard';
import { PageContent } from '../../components/modal/styles';
import { useAccount } from '../../hooks/useAccount';
import { useAddress } from '../../hooks/useAddress';
import useLocales from '../../hooks/useLocales';
import { formatString } from '../../locales';
import { getChainDisplayName } from '../../utils/chains';
import { StyleAddress, StyleQrcodeWrapper, StyleSubTitle, StyleWrapper, Stylefooter } from './styles';

const Page = () => {
  const { chain } = useAccount();
  const address = useAddress();
  const locales = useLocales();

  return (
    <PageContent style={{ marginTop: 0 }}>
      <StyleWrapper>
        <StyleSubTitle>{formatString(locales.onlySupport, getChainDisplayName(chain) || '')}</StyleSubTitle>
        <StyleQrcodeWrapper key={chain?.id}>
          {chain?.id && <CustomQRCode ecl='H' value={address} image={<img src={getChainIcon(chain)} />} />}
        </StyleQrcodeWrapper>
        <StyleAddress>{address}</StyleAddress>
        <Stylefooter>
          <CopyToClipboard variant='button' string={address}>
            {locales.copyAddress}
          </CopyToClipboard>
        </Stylefooter>
      </StyleWrapper>
    </PageContent>
  );
};

export default Page;
